import { ModalOpenParams } from "@containers/SuperOwner/LearningTemplatePackages/LearningTemplateListContainer";
import {
  LearningTemplatePackageBase,
  PackagingAsLearningTemplatePackageBase,
} from "@lib/Api";
import { DragDropContext, Droppable, DropResult } from "react-beautiful-dnd";

import Package from "./index";

type Props = {
  onDragEnd: (result: DropResult) => void;
  reorderPackageList: PackagingAsLearningTemplatePackageBase[];
  handleModalOpen: (modalOpenParams: ModalOpenParams) => void;
  learningTemplate: LearningTemplatePackageBase;
  packagesArray: PackagingAsLearningTemplatePackageBase[];
  isSorting: boolean;
};

export const PackagesComponent = ({
  onDragEnd,
  reorderPackageList,
  handleModalOpen,
  learningTemplate,
  packagesArray,
  isSorting,
}: Props) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="packageList">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {reorderPackageList.map((templatePackage, idx) => (
              <Package
                key={templatePackage.id}
                idx={idx}
                isSorting={isSorting}
                templatePackageId={
                  templatePackage?.material_homework_template_package?.id ??
                  templatePackage.id
                }
                handleModalOpen={handleModalOpen}
                packaging={templatePackage}
                packagesArray={packagesArray}
                learningTemplate={learningTemplate}
                currentPage={1}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
